import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VlLoaderComponent } from './vl-loader.component';



@NgModule({
  declarations: [
    VlLoaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    VlLoaderComponent
  ]
})
export class VlLoaderModule { }
